import { TabsContent } from "@/components/ui/tabs";
import { ProfileTab } from "../ProfileTab";
import { StylesTab } from "../StylesTab";
import { AdminTab } from "../AdminTab";
import { ClassesManager } from "../admin/ClassesManager";
import { GymManager } from "../admin/GymManager";
import { ProfessorScheduleManager } from "../professor/ProfessorScheduleManager";
import { ProfileLoading, StylesLoading, AdminLoading, ClassesLoading } from "../ConfigLoading";
import { useProfile } from "@/hooks/useProfile";

interface TabsContentProps {
  showClassesTab: boolean;
  showAdminTab: boolean;
  showScheduleTab: boolean;
  userRole?: string;
  defaultSubtab?: string;
}

export const TabsContentSection = ({
  showClassesTab,
  showAdminTab,
  showScheduleTab,
  userRole,
  defaultSubtab,
}: TabsContentProps) => {
  const { isLoading } = useProfile();

  return (
    <>
      <TabsContent value="perfil" className="mt-6 space-y-4">
        {isLoading ? <ProfileLoading /> : <ProfileTab />}
      </TabsContent>

      <TabsContent value="estilos" className="mt-6">
        {isLoading ? <StylesLoading /> : <StylesTab />}
      </TabsContent>

      {(showClassesTab && userRole !== 'manager') && (
        <TabsContent value="clases" className="mt-6">
          {isLoading ? <ClassesLoading /> : <ClassesManager />}
        </TabsContent>
      )}

      {showScheduleTab && (
        <TabsContent value="horarios" className="mt-6">
          <ProfessorScheduleManager />
        </TabsContent>
      )}

      {showAdminTab && (
        <TabsContent value="admin" className="mt-6">
          {isLoading ? (
            <AdminLoading />
          ) : (
            userRole === "manager" ? <GymManager /> : <AdminTab defaultSubtab={defaultSubtab} />
          )}
        </TabsContent>
      )}
    </>
  );
};
